<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-size-100">
				<form ref="contract_edit" @submit.prevent="updateContract">
					<md-card>
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="card-icon">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
							</div>
							<h4 class="title">Modification d'un contrat</h4>
						</md-card-header>
						<contract-form :contract="contract" action="edit" :errors="errors"></contract-form>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">
								Enregistrer
							</md-button>
							<md-button class="md-warning"
									   @click="goBack">
								Retour
							</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
		</div>
		<div class="md-layout">
			<div class="md-layout-item md-size-60">
				<form ref="period_edit" @submit.prevent="updateCurrentPeriod">
					<md-card>
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="card-icon">
								<font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
							</div>
							<h4 class="title">
								<div class="flex justify-between">
									<template>
										<span v-if="contract.period.type === 'current_period'">Modification de la période en cours</span>
										<span v-else-if="contract.period.type === 'next_period'">Modification de la période à venir</span>
										<span v-else>Dernière période <span v-if="contract.period.isCanceled">(résiliée)</span></span>
									</template>
									<span class="font-medium text-sm" v-if="contract.periodRepetition > 0">
										({{ (contract.periods.findIndex((period) => period.id === contract.period.id) + 1) + ' sur ' + (contract.periodRepetition + 1) }})
									</span>
								</div>
							</h4>
						</md-card-header>
						<md-card-content>
							<div class="md-layout mt-2">
								<div class="md-layout-item md-size-50">
									<div class="md-vdatepicker" :class="{'md-disabled': !contract.period.isFirst}">
										<datetime v-model="contract.period.dateStart" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
												  input-id="currentDateStart" :disabled="!contract.period.isFirst"
										>
											<label slot="before">Date de début</label>
										</datetime>
										<validation-error :errors="apiValidationErrors.date_start" />
									</div>
								</div>
								<div class="md-layout-item md-size-50">
									<div class="md-vdatepicker" :class="{'md-disabled': !contract.period.isFirst}">
										<datetime v-model="contract.period.dateEnd" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
												  input-id="currentDateEnd" :disabled="!contract.period.isFirst"
										>
											<label slot="before">Date de fin</label>
										</datetime>
										<validation-error :errors="apiValidationErrors.date_end" />
									</div>
								</div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Montant prévu</label>
										<md-input v-model="contract.period.amount" type="text"
											:disabled="!contract.period.isFirst"></md-input>
										<validation-error :errors="apiValidationErrors.amount" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Montant réel</label>
										<md-input v-model="contract.period.future_amount" type="text"></md-input>
										<validation-error :errors="apiValidationErrors.future_amount" />
									</md-field>
								</div>
							</div>
							<div class="pl-3.5 mt-4 flex justify-between">
                                <div>
                                    <p class="font-bold mb-0.5 leading-none">Résiliation de la période</p>
                                    <p v-if="this.$moment(new Date()) > noticeDate" class="font-medium mb-0 leading-none text-xs italic text-danger">
                                        Attention : date de préavis dépassé
                                    </p>
                                </div>
                                <md-button class="md-danger md-icon-button my-0" @click="emptyCancellationFields" :disabled="contract.period.cancelDate === null && contract.period.cancelType === null">Annuler la résiliation</md-button>
							</div>
							<div class="md-layout mt-3">
								<div class="md-layout-item md-size-50">
									<div class="md-vdatepicker">
										<datetime v-model="contract.period.cancelDate"
										          type="date" auto
										          :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
												  input-id="currentCancelDate"
												  placeholder="dd/mm/yyyy"
										          :min-datetime="cancelDatetime.min"
										          :max-datetime="cancelDatetime.max">
											<label slot="before">Date de résiliation</label>
										</datetime>
										<validation-error :errors="apiValidationErrors.cancel_date" />
									</div>
								</div>
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect">
										<label>Raison de la résiliation</label>
										<multiselect v-model="contract.period.cancelType"
										             :options="cancelTypes"
										             :show-labels="false"
										             label="name"
										             track-by="id"
										             placeholder="Raison">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
										<validation-error :errors="apiValidationErrors.cancel_type_id" />
									</div>
								</div>
							</div>
						</md-card-content>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">
								Enregistrer
							</md-button>
							<md-button class="md-warning"
									   @click="goBack">
								Retour
							</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
			<div class="md-layout-item md-size-40">
				<md-card class="mb-10">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
						</div>
						<h4 class="title">Liste des périodes terminées</h4>
					</md-card-header>
					<md-card-content>
						<template v-if="contract.periods.length > 0 || contract.periods[0].date_end < $moment(new Date())">
							<div v-for="(period, index) in contract.periods" :key="period.id">
								<template v-if="period.id !== contract.period.id && $moment(period.date_end) < $moment(new Date())">
									<div class="md-layout" :class="index === 0 ? 'mt-2' : 'mt-4'">
										<div class="md-layout-item md-size-75">
											<p class="font-bold mb-3 text-info leading-none">Période {{ (index + 1) }} sur {{ (contract.periodRepetition + 1) }}</p>
											<div class="flex items-center mb-1.5">
												<p class="mb-0 leading-none w-1/2"><span class="font-bold">Date de début :</span> {{ $moment(period.date_start).format('DD/MM/YYYY') }}</p>
												<template v-if="period.is_canceled">
													<div class="flex items-center justify-between">
														<p class="mb-0 leading-none w-1/2">
															<span class="font-bold">Date de résiliation :</span>
															{{ $moment(period.cancel_date).format('DD/MM/YYYY') }}
														</p>
														<p class="mb-0 leading-none w-1/2">
															<span class="font-bold">Raison de résiliation :</span>
															{{ period.cancel_type.name }}
														</p>
													</div>
												</template>
												<template v-else>
													<p class="mb-0 leading-none w-1/2">
														<span class="font-bold">Date de fin :</span>
														{{ $moment(period.date_end).format('DD/MM/YYYY') }}
													</p>
												</template>
											</div>
											<div class="flex items-center">
												<p class="mb-0 leading-none w-1/2"><span class="font-bold">Montant prévu :</span> {{ period.amount }}€</p>
												<p class="mb-0 leading-none w-1/2"><span class="font-bold">Montant réel :</span> {{ period.future_amount }}€</p>
											</div>
										</div>
									</div>
								</template>
							</div>
						</template>
						<p v-else>Aucune période n'est encore terminée.</p>
					</md-card-content>
				</md-card>
                <md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'list']" />
						</div>
						<h4 class="title">Liste des périodes à venir</h4>
					</md-card-header>
					<md-card-content>
						<template v-if="contract.periods.length > 0 && contract.period">
							<div v-for="(period, index) in contract.periods" :key="period.id">
								<template v-if="$moment(period.date_start) > $moment(new Date())">
									<div class="md-layout" :class="index === 0 ? 'mt-2' : 'mt-4'">
										<div class="md-layout-item md-size-75">
											<p class="font-bold mb-3 text-info leading-none">Période {{ (index + 1) }} sur {{ (contract.periodRepetition + 1) }}</p>
											<div class="flex items-center mb-1.5">
												<p class="mb-0 leading-none w-1/2"><span class="font-bold">Date de début :</span> {{ $moment(period.date_start).format('DD/MM/YYYY') }}</p>
                                                <p class="mb-0 leading-none w-1/2">
                                                    <span class="font-bold">Date de fin :</span>
                                                    {{ $moment(period.date_end).format('DD/MM/YYYY') }}
                                                </p>
											</div>
											<div class="flex items-center">
												<p class="mb-0 leading-none w-1/2"><span class="font-bold">Montant prévu :</span> {{ period.amount }}€</p>
											</div>
										</div>
									</div>
								</template>
							</div>
						</template>
						<p v-else>Aucune période à venir.</p>
					</md-card-content>
				</md-card>
			</div>
		</div>
    </div>
</template>

<script>
import ContractForm from "@/pages/Contracts/components/ContractForm";

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "ContractEdit",
    components: {
        ContractForm, ValidationError
    },
    mixins: [formMixin],
    data() {
        return {
            contract: {
                periods: [{}],
				period: {}
            },
            cancelTypes: [],
            errors: [],
	        cancelDatetime: {
				min: '',
		        max: ''
	        }
        }
    },
	computed: {
    	noticeDate() {
			return this.$moment(this.contract.period.dateEnd).subtract(this.contract.daysNotice, 'days')
		}
	},
    methods: {
        async getContractDetails() {
            const { data } = await this.$store.dispatch('contracts/getContractDetails', { contractId: this.$route.params.contractId })
            this.contract = {
            	id: data.id,
                number: data.number,
                periodDuration: data.period_duration,
                periodRepetition: data.period_repetition ?? 0,
                isSettingUp: !!data.is_setting_up,
                settingUpComment: data.setting_up_comment,
				daysNotice: data.days_notice,
				percentIncrease: data.percent_increase,
                isTacit: !!data.is_tacit,
                billingMonths: data.billing_months.split(','),
                billingInfos: data.billing_info,
                comment: data.comment,
                clientRelation: data.client_relation,
                periods: data.periods,
				period: this.formatPeriod(data),
                isActive: !!data.is_active
            }
        },
        async getCancelTypes() {
            const { data } = await this.$store.dispatch('contracts/getCancelTypes')
            this.cancelTypes = data
        },
        async updateContract() {
            this.errors = []
            try {
                await this.$store.dispatch('contracts/updateContract', {
                    contractId: this.contract.id,
                    number: this.contract.number,
                    is_active: this.contract.isActive,
                    is_setting_up: this.contract.isSettingUp,
                    setting_up_comment: this.contract.settingUpComment,
                    is_tacit: this.contract.isTacit,
					days_notice: this.contract.daysNotice,
					percent_increase: parseFloat(this.contract.percentIncrease),
                    billing_months: this.contract.billingMonths,
                    billing_info: this.contract.billingInfos,
                    comment: this.contract.comment,
                    client_relation: this.contract.clientRelation,
                    period_duration: this.contract.periodDuration,
                    period_repetition: this.contract.periodRepetition,
                })
                await this.$store.dispatch('alerts/success', 'Contrat modifié')
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        async updateCurrentPeriod() {
            this.resetApiValidation()
            try {
                const { data } = await this.$store.dispatch('contracts/updatePeriod', {
                    periodId: this.contract.period.id,
					date_start: this.$moment(this.contract.period.dateStart).format('YYYY-MM-DD'),
					date_end: this.$moment(this.contract.period.dateEnd).format('YYYY-MM-DD'),
					cancel_date: this.contract.period.cancelDate ? this.$moment(this.contract.period.cancelDate).format('YYYY-MM-DD') : null,
					cancel_type_id: this.contract.period.cancelType ? this.contract.period.cancelType.id : null,
					amount: parseFloat(this.contract.period.amount),
					future_amount: parseFloat(this.contract.period.future_amount)
                })

	            this.contract.periods = data.periods
                this.contract.period = this.formatPeriod(data)

                await this.$store.dispatch('alerts/success', 'Période modifiée')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
		formatDate(date) {
        	const formatted = this.$moment(date).format()
        	return formatted === 'Invalid date' ? null : formatted
		},
	    formatPeriod(contract) {
		    const periodType = contract.current_period ? 'current_period' : (contract.next_period ? 'next_period' : 'last_period')
		    const periodStart = this.formatDate(contract[periodType].date_start)
		    const periodEnd = this.formatDate(contract[periodType].date_end)

		    this.cancelDatetime.min = periodStart
		    this.cancelDatetime.max = periodEnd

		    return {
			    type: periodType,
			    id: contract[periodType].id,
			    dateStart: periodStart,
			    dateEnd: periodEnd,
			    isCanceled: contract[periodType].is_canceled,
			    cancelDate: this.formatDate(contract[periodType].cancel_date),
			    cancelType: contract[periodType].cancel_type,
			    amount: contract[periodType].amount,
			    future_amount: contract[periodType].future_amount,
			    isFirst: contract.periods.findIndex((period) => period.id === contract[periodType].id) === 0
		    }
	    },
        emptyCancellationFields () {
            this.contract.period.cancelDate = null
            this.contract.period.cancelType = null
        },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        this.getContractDetails()
        this.getCancelTypes()
    }
}
</script>

<style scoped>

</style>
